
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/science-figures/ko",
      function () {
        return require("private-next-pages/science-figures/ko.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/science-figures/ko"])
      });
    }
  